// extracted by mini-css-extract-plugin
export var fadingColorsHolder = "FadingColors-module--fadingColorsHolder--b7833";